/**
 * Description: 输入面板
 * User: 常胤 <satans17@gmail.com>
 * Date: 16/01/23
 * Copyright(c) 2016 Taobao.com
 *  update:
 *    2016-01-25 changyin
 *      * 剥离所有和业务相关的代码
 */

import events from 'events';
import $ from '@ali/tarzan-zepto';
import inputPanelTemplate from '../../baseui/index.js';
import Input from './input/index';
import util from '../../../lib/util';
import InputTip from './inputtip/index';
import { smileytip } from './smileytip/index';

require('./style.scss');

const EMOJI_REG = /\ud83c[\udf00-\udfff]|\ud83d[\udc00-\ude4f]|\ud83d[\ude80-\udeff]/gim;
const LOG_C = 'inputpanel';

const PC = util.isPC();

export default class InputPanel extends events {

  constructor(config) {
    super();
    /**
     * user config
     */
    this.config = config;
    /**
     * root dom
     */
    this.$container = $(config.container);
    /**
     * 埋点
     */
    this.log = config.log;


    /**
     * 插件面板
     * @type {null}
     */
    this.$plugin = null;

    /**
     * 输入toolbar
     */
    this.__$inputToolbar = null;

    /**
     * 快捷短语
     */
    this.$shortcuts = null;
    /**
     * 输入对象，语音&文本
     */
    this.input = null;

    /**
     * 输入提示对象
     * @type {null}
     */
    this.inputTip = null;

    this.__render();
    this.__bindEvt();
    this.__hack();
  }

  /**
   * 渲染
   * @private
   */
  __render() {
    const $container = this.$container;
    $container.html(inputPanelTemplate.frame({ type: 'footer' }));

    // 缓存常用对象
    this.__$inputToolbar = $container.find('.J_InputToolbar');
    this.$plugin = $container.find('.J_ExtPanel');
    this.$shortcuts = $container.find('.J_Shortcuts');

    this.input = this.__initInput();

    this.$inputWrap = $container.find('.J_InputWrap');
    this.$sendShortcut = $container.find('.J_OrderSelect');
    this.$sendShortcutInner = $container.find('.J_Orderlist');
    this.$pluginTrigger = $container.find('.J_ShowPluginBoard');
    this.$inputBtn = $container.find('.J_InputBtn');
    this.$slideUp = $container.find('.J_SlideUp');
    this.$emojiBtn = $container.find('.m-emoji-btn');
  }


  /**
   * 提交数据
   * @param data 数据
   * @param type 数据类型  connect order imgTag
   * @param show 是否显示
   * @param post 是否提交
   */
  submit(data, type = 'text', show = true, post = true) {
    let convertData = data;
    // 如果需要发送到后端的emoji表情,替换成[表情]文字
    if (post && util.isString(convertData) && EMOJI_REG.test(convertData)) {
      convertData = data.replace(EMOJI_REG, '[\u8868\u60C5]');
    }
    if (post && util.isObject(convertData) && EMOJI_REG.test(convertData.q)) {
      convertData.q = convertData.q.replace(EMOJI_REG, '[\u8868\u60C5]');
    }
    this.emit('message', [convertData, type, show, post]);
    // 发送消息之后,需要滚动到最底部
    if (show) {
      this.scrollToBottom();
    }
  }

  focus() {
    const $container = this.$container;
    if (this.input.field.inputFormat === 'number') {
      $container.find('.J_NumberField').trigger('focus');
    } else {
      $container.find('.J_Field').trigger('focus');
    }
  }

  blur() {
    const $container = this.$container;
    if (this.input.field.inputFormat === 'number') {
      $container.find('.J_NumberField').trigger('blur');
    } else {
      $container.find('.J_Field').trigger('blur');
    }
    this.__hackFocus();
  }

  __hackFocus() {
    const $$container = $('.m-alicare-body');

    // 解决focus到输入框后不能失去焦点的问题
    $$container.attr('tabindex', 1);
    // 进页面第一次点击不生效,应该是第一次没有focus,机智的我,进页面先手动触发下focus,红红火火恍恍惚惚
    $$container.trigger('focus');
  }

  /**
   * 设置输入提示文本
   */
  setTipText(text) {
    this.inputTip = new InputTip(text, this.$container);
    this.inputTip.on('send', (ev) => {
      this.submit(ev.text);
    });
  }

  setPlaceholder(text) {
    this.input.field.$field.attr('placeholder', text);
  }

  __bindEvt() {
    const $container = this.$container;
    const Action = PC ? 'click' : 'tap';
    this.$inputBtn.on(Action, (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      // classname active 改成动效
      const hasActiveSendBtn = this.$inputBtn.hasClass('active');
      if (hasActiveSendBtn) {
        // 发送按钮
        this.__sendTextMessage();
        this.input.field.adjustTextareaHeight();
      } else {
        // // 插件按钮
        // const $pluginBtn = this.$inputBtn.find('.J_ShowPluginBoard');
        // if ($pluginBtn.hasClass('rotated')) {
        //   this.hidePlugin();
        //   // 交互要求：先收起插件面板，再 focus input 唤起键盘
        //   setTimeout(() => {
        //     this.focus();
        //   }, 300);
        // } else {
        //   // this.hideSlideUp();
        //   this.showPlugin();
        // }
      }
    });

    $container.find('.J_Field').on('input', (ev) => {
      const $target = $(ev.currentTarget);
      $(document).trigger('inputing');
      smileytip($target.val(), (text) => {
        this.submit(text, 'liveImage');
        $target.val('');
        $target.trigger('change');
      });
    });

    $container.find('.J_Field,.J_NumberField').on('keydown keyup', (ev) => {
      const f = this.input.field;
      const val = f.getValue() || '';
      if (ev.keyCode === 13 && val) {
        this.__sendTextMessage();
        this.input.field.adjustTextareaHeight();
        ev.preventDefault();
        this.log.send({
          c: LOG_C,
          d: 'enter',
        });
      }
    });
    $container.find('.J_Field,.J_NumberField').on('focus', () => {
      if (this.inputTip) {
        this.inputTip.showTip();
      }
      this.emit('focus');
      this.__scrollIntoView();
    });

    $container.find('.J_Field').on('blur', () => {
      if (this.inputTip) {
        this.inputTip.hideTip();
      }
      setTimeout(() => {
        this.__hackFocus();
      }, 100);
    });

    // 快捷短语左右滑的埋点
    let startX = 0;
    this.$shortcuts.on('touchstart', (ev) => {
      startX = ev.touches[0].pageX;
    });
    this.$shortcuts.on('touchend', (ev) => {
      const endX = ev.changedTouches[0].pageX;
      if (endX - startX > 10) {
        this.log.send({
          c: 'shortcut',
          d: 'swiperight',
        });
      } else if (endX - startX < -10) {
        this.log.send({
          c: 'shortcut',
          d: 'swipeleft',
        });
      }
    });
  }

  /**
   * 往slideup里增加节点
   * @param {any} hideInput 是否遮挡输入框
   */
  appendSlideUp($node) {
    this.$slideUp.html($node);
  }

  /**
   * 展示从下浮出的操作区
   * @param {any} hideInput 是否遮挡输入框
   */
  showSlideUp(hideInput) {
    this.$slideUp.removeClass('slide-out-to-bottom').addClass('slide-in-from-bottom');
    this.hideShortcuts();
    this.resize();
    this.scrollToBottom();
    // 隐藏输入框
    if (hideInput) {
      this.hideInputPanel();
    }
  }

  /**
   * 隐藏浮出的内容，这时候要显示快捷短语
   */
  hideSlideUp(hideShortcuts = false) {
    this.$slideUp.removeClass('slide-in-from-bottom').addClass('slide-out-to-bottom');
    this.$slideUp.html('');
    // 云客服 SOP 交互不需要展示快捷短语
    if (!hideShortcuts) this.showShortcuts();
    this.showInputPanel();
    this.resize();
    this.scrollToBottom();
  }

  showInputPanel() {
    this.$inputWrap.show();
  }

  hideInputPanel() {
    this.$inputWrap.hide();
  }

  /**
   * 初始化输入类
   * @returns {*}
   * @private
   */
  __initInput() {
    const $container = this.$container;
    const input = new Input({
      log: this.log,
      container: $container.find('.J_InputForm'),
      inputType: this.config.inputType,
    });
    const $inputField = input.field.$field;
    const $inputForm = $container.find('.J_InputForm');
    const $toolBar = $container.find('.J_InputToolbar');
    // 切换输入方式：语音or文本
    input.on('switch', (ev) => {
      if (ev.inputType === 'keyboard') {
        input.field.focus();
      } else {
        input.field.blur();
      }
      if (!ev.force) {
        this.log.send({
          c: LOG_C,
          d: ev.inputType,
        });
      }
      this.hidePlugin();
      setTimeout(() => {
        $toolBar.height($inputForm.height());
      }, 0);
    });

    // 需要调整body高度
    input.on('resize', () => {
      this.resize();
      this.scrollToBottom();
    });

    $inputField.on('focus', util.buffer(() => {
      if (document.activeElement.tagName === 'TEXTAREA') {
        // 隐藏插件
        this.hidePlugin();
        this.log.send({
          c: LOG_C,
          d: 'focus',
        });
      }
    }, 50));

    // focus & blur event
    $inputField.on('blur', () => {
      this.emit('blur');
    });

    $inputField.on('keyup', () => {
      this.emit('keyup');
    });

    input.on('voice', (result) => {
      this.submit(result, 'text', false, true);
      this.emit('voice', {
        text: result,
      });
      this.showShortcuts();
    });

    input.on('voicestart', () => {
      this.emit('voicestart');
      this.hideShortcuts();
    });

    input.on('voicecancel', () => {
      this.emit('voicecancel');
      this.showShortcuts();
    });

    return input;
  }

  __sendTextMessage() {
    const f = this.input.field;
    let val = f.getValue() || '';

    val = val.replace(/</g, '&lt;').replace(/>/g, '&gt;').trim();

    if (val) {
      this.submit(val);
      f.setValue('');
    }
    f.focus();
  }

  /**
   * fix安卓键盘顶起的bug
   * @private
   */
  __hack() {
    const originWinHeight = $(window).height();
    if (util.UA.isAndroid) {
      window.onresize = () => {
        const nowHeight = $(window).height();
        $('body').css({
          bottom: nowHeight - originWinHeight,
          height: nowHeight,
        });
      };
    }
  }

  /**
   * 隐藏加号
   * @return {[type]} [description]
   */
  hidePlus() {
    this.$pluginTrigger.hide();
  }

  /**
   * 添加插件
   * @param config
   *  config.icon 插件对应iconfont
   *  config.title 插件对应标题
   *  config.action 点击事件
   */
  addPlugin(config) {
    const Action = PC ? 'click' : 'tap';
    const $el = $(`<div class="item ${config.name}" aria-label="${config.title}" role="button">
      <div class="icon-bg">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-${config.icon}"></use>
        </svg>
      </div>
      <span aria-hidden="true">${config.title}</span>
    </div>`);

    $el.on(Action, (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      config.action.call(this);
    });
    this.$plugin.find('.J_Plugins').append($el);
  }

  /**
   * 隐藏特定插件
   * @param name
   */
  hideTargetPlugin(name) {
    this.$plugin.find(`.${name}`).hide();
  }

  /**
   * 显示特定插件
   * @param name
   */
  showTargetPlugin(name) {
    this.$plugin.find(`.${name}`).show();
  }

  /**
   * 显示插件
   */
  showPlugin() {
    this.input.field.blur();
    this.$pluginTrigger.attr('aria-label', '收起插件');
    this.$pluginTrigger.addClass('rotated');

    this.$plugin.show();
    this.resize();
    this.scrollToBottom();
  }

  /**
   * 隐藏插件
   */
  hidePlugin() {
    this.emit('hidePlugin');
    this.$pluginTrigger.attr('aria-label', '展开插件');
    this.$pluginTrigger.removeClass('rotated');
    this.$plugin.hide();
    this.resize();
  }

  /**
   * 显示快捷短语
   */
  showShortcuts() {
    const $shortcutsContent = this.$shortcuts.find('.m-shortcuts');
    this.$shortcuts.show();
    // 将快捷短语更新到最左
    $shortcutsContent.scrollLeft(0);
  }
  /**
   * 隐藏快捷短语
   */
  hideShortcuts() {
    this.$shortcuts.hide();
  }

  /**
   * 重新设置body高度和top bottom
   */
  resize() {
    this.emit('resize');
  }
  /**
   * 需要body滚到最底部
   */
  scrollToBottom() {
    this.emit('scrollToBottom');
  }

  __scrollIntoView() {
    const form = this.$container.find('.J_InputForm')[0];
    setTimeout(() => {
      form.scrollIntoView();
    }, 300);
  }
}



// WEBPACK FOOTER //
// ./src/component/view/footer/index.js